export default __webpack_public_path__ + "static/testimonials4-a4e0cc890989af6bac4b25a10bc12bd5.jpg";